import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import apiService from '../../services/api.service'
import { messageActions } from '../../store/message'

const BASE_PATH = '/lottustech/pixautomatico/cobranca/reconciliacao'
const crud = build(null, BASE_PATH)
const prefix = 'crudReconciliacaoPixAutomatico'

const actions = new Action(prefix, crud)
const newTypes = {
  SET_RESULTADO: `${prefix}setResultado`,
}

const types = Object.assign({}, actions.types, newTypes)

actions.setResultado = (resultado) => {
  return {
    type: types.SET_RESULTADO,
    payload: resultado,
  }
}

actions.carregarCandidatos = () => {
  return (dispatch) => {
    dispatch(actions.fetchRecords())
    return apiService
      .get(BASE_PATH)
      .then(({ data }) => {
        dispatch(actions.setRecords(data))
        dispatch(actions.hideLoader())
      })
      .catch((err) => {
        dispatch(actions.hideLoader())
        dispatch(
          messageActions.messageShowMessages(makeMessages(['Não foi possível carregar os candidatos a reconciliação'], 'error'))
        )
      })
  }
}

actions.reconciliar = (oidsItens) => {
  return (dispatch) => {
    return apiService
      .post(BASE_PATH, { oidsItens })
      .then(({ data }) => {
        dispatch(actions.setResultado(data))
        dispatch(actions.clearSelectedRecords())
        dispatch(actions.carregarCandidatos())
        const quantidadeErros = Object.keys(data.erros || {}).length
        const tipo = quantidadeErros > 0 ? 'warn' : 'success'
        dispatch(
          messageActions.messageShowMessages(
            makeMessages([`${data.sucesso.length} item(ns) reconciliado(s), ${quantidadeErros} erro(s)`], tipo)
          )
        )
      })
      .catch((err) => {
        const messages = err.response ? [err.response.data] : ['Erro ao reconciliar itens']
        dispatch(messageActions.messageShowMessages(makeMessages(messages, 'error')))
      })
  }
}

const makeMessages = (messages, type) => {
  let sticky = false
  let summary = 'Sucesso!'
  if (type === 'error') {
    summary = 'Erro!'
    sticky = true
  } else if (type === 'warn') {
    summary = 'Aviso!'
    sticky = true
  }
  return messages.map((message) => {
    return {
      sticky: sticky,
      summary: summary,
      severity: type,
      detail: message,
    }
  })
}

export { types, actions }
